module.exports = __webpack_public_path__ + "media/iconic/warning-663e9f72.svg";